<template>
  <b-modal v-model="visible" size="lg" title="Service Detail & Estimation" hide-footer>
    <div v-if="service" class="p-2">
       <div class="d-flex justify-content-between mb-3 border-bottom pb-2">
          <div>
              <h5 class="mb-0 text-primary">Service: {{ service.type }}</h5>
              <p class="small text-muted mb-0">Ticket ID: #{{ service.id }} | Date: {{ service.date }}</p>
          </div>
          <b-badge variant="info" class="p-2 h-50">Estimated: ₹{{ service.estimatedCost }}</b-badge>
       </div>

       <b-row class="mb-4">
          <b-col md="6">
              <strong>Complaint reported:</strong>
              <p class="text-muted">{{ service.complaint }}</p>
          </b-col>
          <b-col md="6">
              <strong>Workshop location:</strong>
              <p class="text-muted">Pridel Maintenance Yard - Sector 5</p>
          </b-col>
       </b-row>

       <h6>Spare Parts & Labor Estimation</h6>
       <div class="table-responsive">
          <table class="table table-sm table-hover table-bordered">
             <thead class="thead-light">
                 <tr>
                     <th>Description</th>
                     <th>Quantity</th>
                     <th class="text-right">Price</th>
                 </tr>
             </thead>
             <tbody>
                 <tr v-for="(item, i) in spareParts" :key="i">
                     <td>{{ item.name }}</td>
                     <td>{{ item.qty }}</td>
                     <td class="text-right">₹{{ item.price }}</td>
                 </tr>
                 <tr class="bg-light font-weight-bold">
                     <td colspan="2">Total Estimation</td>
                     <td class="text-right">₹{{ service.estimatedCost }}</td>
                 </tr>
             </tbody>
          </table>
       </div>

       <div class="mt-4 d-flex justify-content-between">
          <b-button variant="outline-secondary" @click="visible = false">Close</b-button>
          <div>
            <b-button variant="outline-primary" @click="$emit('download-estimate', service)" class="mr-2">
              <md-icon size="18">download</md-icon> PDF Estimate
            </b-button>
            <b-button variant="primary" @click="$emit('go-to-maintenance', service)">
              <md-icon size="18" class="text-white">launch</md-icon> Open Native Record
            </b-button>
          </div>
       </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ServiceEstimationModal',
  props: {
    visible: { type: Boolean, required: true },
    service: { type: Object, default: null },
    spareParts: { type: Array, required: true }
  }
};
</script>



// WEBPACK FOOTER //
// ServiceEstimationModal.vue?6d6ad16e